export const getMiliseconds = (seconds?: number | string) => {
  if (!seconds) return 0;

  return Number(seconds) * 1000;
};
